import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Badge } from './Badge';
import { IconButton } from './IconButton';
export function ObjectPreview({
  title,
  icon,
  status,
  meta,
  children,
  actions,
  destructiveAction,
  onClose,
  hideTitle = false,
}: {
  title: string;
  /** The surrounding panel already supplies a heading. */
  hideTitle?: boolean;
  icon?: ReactNode;
  status?: { label: string; tone: 'success' | 'warn' | 'urgent' | 'info' | 'neutral' };
  meta?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  destructiveAction?: ReactNode;
  onClose?: () => void;
}) {
  const hasHeader = !hideTitle || Boolean(status || onClose);
  return (
    <article data-slot="object-preview" aria-label={hideTitle ? title : undefined} className="min-w-0 p-4">
      {hasHeader && (
        <header className="flex min-w-0 items-start gap-3">
          {!hideTitle && icon && <span className="mt-1 text-fg-muted [&_svg]:size-4">{icon}</span>}
          <div className="min-w-0 flex-1">
            {!hideTitle && <h3 className="type-subheading break-words">{title}</h3>}
            {status && (
              <div className="mt-2">
                <Badge variant={status.tone} solid>
                  {status.label}
                </Badge>
              </div>
            )}
          </div>
          {onClose && (
            <IconButton variant="ghost" size="sm" aria-label="Закрыть карточку" onClick={onClose}>
              <X />
            </IconButton>
          )}
        </header>
      )}
      {meta && (
        <div
          className={
            hasHeader
              ? 'mt-3 flex flex-wrap items-center gap-x-1 gap-y-2 text-xs text-fg-muted'
              : 'flex flex-wrap items-center gap-x-1 gap-y-2 text-xs text-fg-muted'
          }
        >
          {meta}
        </div>
      )}
      {children && <div className="mt-4 flex min-w-0 flex-col gap-4 text-sm">{children}</div>}
      {actions && <div className="mt-4 flex flex-wrap items-center gap-2">{actions}</div>}
      {destructiveAction && <div className="mt-4 border-t border-line pt-3">{destructiveAction}</div>}
    </article>
  );
}
